import { ClaimRewardModalProps } from './props';
import { Modal } from '@starsoft/common/components';
import { AuthService } from '@/services/AuthService';
import { PropsWithChildren } from 'react';
import styles from './styles.module.scss';

export default function ClaimRewardModalLayout({
  handleContainer,
  isOpen,
  onClose,
  children,
}: PropsWithChildren<ClaimRewardModalProps>) {
  return (
    <Modal open={isOpen && AuthService.isAuthorized()} onClose={onClose}>
      <div className={styles.container} onClick={handleContainer}>
        {children}
      </div>
    </Modal>
  );
}
